/**
 * MediaPool (API)
 * MediaPool関連のAPI
 */
import session from './session'
import file from './file'

var uri = process.env.API_ENDPOINT

export default {
    saveImage (data) {
        return session.post(uri + '/api/mp/save_image/', data)
    },
    saveTagImage (data) {
        console.debug('***** Called saveImage *****')
        return file.post(uri + '/api/mp/save_image/', data)
    },
    getAllImages () {
        console.debug('***** Called getAllImages *****')
        return session.get(uri + '/api/mp/get_all_images/')
    },
    getTagImages (tag) {
        console.debug('***** Called getTagImages *****')
        return session.get(uri + '/api/mp/get_tag_images/' + tag + '/')
    },
    getStoryOrgImages (id) {
        console.debug('***** Called getStoryOrgImages *****')
        return session.get(uri + '/api/mp/get_story_org_images/' + id + '/')
    },
    getIconOrgImages () {
        console.debug('***** Called getIconOrgImages *****')
        return session.get(uri + '/api/mp/get_icon_org_images/')
    },
    getImage () {
        console.debug('***** Called getImage *****')
        return session.get(uri + '/api/mp/get_image/')
    },
    deleteImage (id) {
        console.debug('***** Called deleteImage *****')
        return session.delete(uri + '/api/mp/delete_image/' + id + '/')
    },
    updateImage (data) {
        console.debug('***** Called updateImage *****')
        return session.put(uri + '/api/mp/update_image/', data)
    },
    getImageReferrers (id) {
        console.debug('***** Called getImageReferrers *****')
        return session.get(uri + '/api/mp/get_image_referrers/' + id + '/')
    },
    // linkImage (ref_id, image_id, desc) {
    //     console.debug('***** Called lnikImage *****')
    //     return session.put(uri + '/api/mp/link_image/', {referrer_id: ref_id, image_id: image_id, description: desc})
    // },
    // unlinkImage (ref_id, image_id) {
    //     console.debug('***** Called lnikImage *****')
    //     return session.put(uri + '/api/mp/unlink_image/', {referrer_id: ref_id, image_id: image_id})
    // },
    saveVideo (data) {
        return session.post(uri + '/api/mp/save_video/', data)
    },
    getAllVideos () {
        console.debug('***** Called getAllVideos *****')
        return session.get(uri + '/api/mp/get_all_videos/')
    },
    getVideo () {
        console.debug('***** Called getVideo *****')
        return session.get(uri + '/api/mp/get_video/')
    },
    deleteVideo (id) {
        console.debug('***** Called deleteVideo *****')
        return session.delete(uri + '/api/mp/delete_video/' + id + '/')
    },
    renameVideo (id, name) {
        console.debug('***** Called renameVideo *****')
        return session.put(uri + '/api/mp/rename_video/', {video_id: id, name: name})
    },
    updateVideo (data) {
        console.debug('***** Called updateVideo *****')
        return file.put(uri + '/api/mp/update_video/', data)
    },
    getVideoReferrers (id) {
        console.debug('***** Called getVideoReferrers *****')
        return session.get(uri + '/api/mp/get_video_referrers/' + id + '/')
    },
    updateOrderImage(data) {
        console.debug('***** Called updateOrderImage *****')
        return session.put(uri + '/api/mp/update_order_image/', data)
    },
    updateOrderVideo(data) {
        console.debug('***** Called updateOrderVideo *****')
        return session.put(uri + '/api/mp/update_order_video/', data)
    }
    // linkVideo (ref_id, video_id, desc) {
    //     console.debug('***** Called lnikVideo *****')
    //     return session.put(uri + '/api/mp/link_video/', {referrer_id: ref_id, video_id: video_id, description: desc})
    // },
    // unlinkVideo (ref_id, video_id) {
    //     console.debug('***** Called lnikVideo *****')
    //     return session.put(uri + '/api/mp/unlink_video/', {referrer_id: ref_id, video_id: video_id})
    // },
}


// WEBPACK FOOTER //
// ./src/api/mediapool.js